import React from "react";
import Helmet from "react-helmet";
import Jumbotron from "../components/Jumbotron/Jumbotron";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import Link from "gatsby-link";

class Index extends React.Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges;
    return (
      <div className="Homepage">
        <Helmet title={config.siteTitle} />
        <SEO postEdges={postEdges} />
        <Jumbotron message="We make games. Sorry." />
        <div className="Container">
          <h2>Terribly Sorry Studios is an indie game developer based out of Toronto, Canada.</h2>
          <p>
            Terribly Sorry Studios is a Canadian collaborative game studio founded in 2015. We’re here to make fun games and chew gum, and we’re all outta gum.
            <br /><br />
            Stay tuned on our <Link to="/blog" key="bloglink">Blog</Link> and <a href="https://twitter.com/sorrystudios" target="_blank">Twitter</a> for updates.
          </p>
        </div>
        <div className="Container">
          <PostListing postEdges={postEdges} />
        </div>
      </div>
    );
  }
}

export default Index;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 5
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx